import styles from './resultBox.module.css';

const ResultBox = ({ result }) => {

    let supporting = [];
    result['support'].forEach(source => {
        supporting.push(
            <div>
                <p> Source Name: {source['source_name']} </p>
                <p> Source Link: {source['source_link']} </p>
                <p> Credibility Score: {source['source_cred_score']} </p>
            </div>
        )        
    });

    let opposing = [];
    result['oppose'].forEach(source => {
        opposing.push(
            <div>
                <p> Source Name: {source['source_name']} </p>
                <p> Source Link: {source['source_link']} </p>
                <p> Credibility Score: {source['source_cred_score']} </p>
            </div>
        )        
    });

    return(
        <div className = {styles.body}>
            <div className = {styles.upperBox}>
                Claim: {result['claim_text']}
                Verdict: {result['truth_value']}
            </div>
            <div className = {styles.lowerBox}>
                {supporting}
                {opposing}
            </div>
        </div>
    )
}

export default ResultBox;